import { ADS_NOTICE_VERSION, allowsOpenAIAds, requiresAdvertisingConsent, type AdsChoice, type AdsConsentRecord } from "../../supabase/functions/_shared/openaiAdsPolicy";
export { allowsOpenAIAds, requiresAdvertisingConsent };
export const ADS_OPTOUT_KEY = "openai_ads_opt_out";
const HISTORY_KEY = "openai_ads_consent_history";
const VISITOR_KEY = "openai_ads_consent_visitor";
export const ADS_NOTICE_TEXT = "Allow OpenAI advertising measurement? OpenAI receives page and referral URLs, timestamps, browser and device information, IP addresses and advertising identifiers to measure quote requests and optimize ads. We do not share your name, email, phone, inventory or payments for customer matching. You can change your choice in Advertising settings or our Privacy Policy. Your quote is unaffected.";
let regionLookup: Promise<string | null> | undefined;

function readHistory(): AdsConsentRecord[] {
  try { const history: unknown = JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]"); return Array.isArray(history) ? history : []; }
  catch { return []; }
}

function readRefusal(): boolean {
  try {
    return localStorage.getItem(ADS_OPTOUT_KEY) === "denied" ||
      localStorage.getItem("oaiq_consent") === "false" ||
      document.cookie.split("; ").includes("__oaiq_consent=false") ||
      localStorage.getItem("cookie_consent") === "false";
  } catch { return true; }
}

export async function getOpenAIAdsChoice(): Promise<AdsChoice> {
  regionLookup ??= (async () => {
    try {
      const response = await fetch("/cdn-cgi/trace", { signal: AbortSignal.timeout(2000), cache: "no-store" });
      if (!response.ok) return null;
      const region = (await response.text()).match(/^loc=([A-Z]{2})$/m)?.[1];
      return region && region !== "XX" && region !== "T1" ? region : null;
    } catch { return null; }
  })();
  const region = await regionLookup;
  const privacyNavigator = navigator as Navigator & { globalPrivacyControl?: boolean };
  const optedOut = readRefusal() || privacyNavigator.globalPrivacyControl === true || navigator.doNotTrack === "1";
  const consentHistory = readHistory();
  const consentRecord = consentHistory.at(-1);
  const advertising = optedOut ? "denied" : consentRecord?.noticeVersion === ADS_NOTICE_VERSION ? consentRecord.advertising : "unanswered";
  return { region, advertising, optedOut, consentRecord, consentHistory,
    noticeVersion: ADS_NOTICE_VERSION, checkedAt: new Date().toISOString() };
}

export async function saveOpenAIAdsChoice(advertising: "accepted" | "denied"): Promise<void> {
  const choice = await getOpenAIAdsChoice();
  const visitorId = localStorage.getItem(VISITOR_KEY) || crypto.randomUUID();
  localStorage.setItem(VISITOR_KEY, visitorId);
  const record: AdsConsentRecord = { id: crypto.randomUUID(), visitorId, advertising, region: choice.region,
    recordedAt: new Date().toISOString(), noticeVersion: ADS_NOTICE_VERSION };
  localStorage.setItem(HISTORY_KEY, JSON.stringify([...readHistory(), record]));
  if (advertising === "denied") localStorage.setItem(ADS_OPTOUT_KEY, "denied");
  else localStorage.removeItem(ADS_OPTOUT_KEY);
  window.dispatchEvent(new Event("openai-ads-choice-change"));
}

export function declineOpenAIAds(): void { void saveOpenAIAdsChoice("denied"); }
export function openOpenAIAdsSettings(): void { window.dispatchEvent(new Event("openai-ads-settings-open")); }